import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  DOCUMENT_TYPES,
  SERVICES,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

// eslint-disable-next-line max-len
const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/${COMMON_QUERY_PARAMS.SERVICE}-attachments/${COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID}`;

export interface RenameFileAttachmentCommandPayload {
  fileId: string;
  fileAttachmentId: string;
  service: SERVICES;
  newName: string;
  documentType?: DOCUMENT_TYPES;
}

async function renameFileAttachmentCommand({
  fileId,
  fileAttachmentId,
  service,
  newName,
  documentType,
}: RenameFileAttachmentCommandPayload): Promise<BaseBackResponse> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId)
      .replace(COMMON_QUERY_PARAMS.SERVICE, service)
      .replace(COMMON_QUERY_PARAMS.FILE_ATTACHMENT_ID, fileAttachmentId);

    const response = await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        newName,
        documentType,
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default renameFileAttachmentCommand;
